export default __webpack_public_path__ + "static/media/IMG-20240708-WA0015.d9e8a703.jpg";